declare var process: any;
declare var window: any;

/**
 * Returns true, if running on the Electron platform.
 */
export function isElectron(): boolean {
	// Renderer process
	if (typeof window !== "undefined" && !!window && !!window.process && !!window.process.type) {
		return true;
	}
	// Main process
	if (typeof process !== "undefined" && !!process && typeof process.versions === "object" && !!process.versions.electron) {
		return true;
	}
	// Detect the user agent when the `nodeIntegration` option is set to true
	if (typeof navigator === "object" && typeof navigator.userAgent === "string") {
		const ua = navigator.userAgent;
		if (ua.indexOf("Electron") >= 0 || ua.toLowerCase().indexOf(" electron/") > -1) {
			return true;
		}
	}
	return false;
}

function getIpcRendererSafe(): any | null {
	try {
		const w: any = typeof window !== "undefined" ? window : undefined;
		const req = w?.require ?? undefined;
		if (!req) {
			return null;
		}
		const {ipcRenderer} = req("electron");
		return ipcRenderer ?? null;
	} catch (e) {
		return null;
	}
}

export function callElectron(functionName: string, ...args: any[]) {
	if (isElectron()) {
		const ipcRenderer = getIpcRendererSafe();
		if (ipcRenderer) {
			ipcRenderer.send(functionName, ...args);
		}
	}
}

export async function callAsyncElectron(functionName: string, onProcess?: ((result: any) => void) | null, ...args: any[]): Promise<any> {
	if (isElectron()) {
		const ipcRenderer = getIpcRendererSafe();
		if (!ipcRenderer) {
			console.warn("ipcRenderer not available. Check contextIsolation/nodeIntegration.");
			return undefined;
		}

		return await new Promise((resolve, reject) => {
			const hasOnProcess = typeof onProcess === "function";

			const onProc = (event, arg) => {
				if (hasOnProcess) {
					try {
						onProcess!(arg);
					} catch (e) {
						console.error("Error in onProcess callback:", e);
					}
				}
			};

			const onError = (event, arg) => {
				if (hasOnProcess) {
					ipcRenderer.removeListener("asynchronous-process", onProc);
				}
				ipcRenderer.removeListener("asynchronous-error", onError);
				ipcRenderer.removeListener("asynchronous-reply", onFinish);
				reject(arg);
			};

			const onFinish = (event, arg) => {
				if (hasOnProcess) {
					ipcRenderer.removeListener("asynchronous-process", onProc);
				}
				ipcRenderer.removeListener("asynchronous-error", onError);
				ipcRenderer.removeListener("asynchronous-reply", onFinish);
				resolve(arg);
			};

			if (hasOnProcess) {
				ipcRenderer.on("asynchronous-process", onProc);
			}
			ipcRenderer.on("asynchronous-error", onError);
			ipcRenderer.on("asynchronous-reply", onFinish);

			ipcRenderer.send(functionName, ...args);
		});
	} else {
		console.log("callAsyncElectron (Web-Fallback)", functionName, args);
		return undefined;
	}
}
